export default function showFilter() {
  const form = document.querySelector('.filter__form');
  const formData = new FormData(form);
  
  // Извлекаем значения
  const country = formData.get('country') || 'all';
  const make = formData.get('make') || 'all';
  const model = formData.get('model') || 'all';
  
  // Другие параметры - очищаем от пробелов
  const mileageFrom = formData.get('mileage_from')?.trim().replace(/\s+/g, '') || '';
  const mileageTo = formData.get('mileage_to')?.trim().replace(/\s+/g, '') || '';
  const priceFrom = formData.get('price_from')?.trim().replace(/\s+/g, '') || '';
  const priceTo = formData.get('price_to')?.trim().replace(/\s+/g, '') || '';
  const yearFrom = formData.get('year_from')?.trim() || '';
  const yearTo = formData.get('year_to')?.trim() || '';

  // ✅ Формируем сегменты
  const segments = [];
  
  // Если выбрана марка (не all) - добавляем страну (даже если all)
  if (make && make !== 'all') {
    segments.push(country); // country может быть 'all'
    segments.push(make);
  } else {
    // Если марка не выбрана - добавляем только страну если она не all
    if (country && country !== 'all') {
      segments.push(country);
    }
  }
  
  // Добавляем модель только если она не all
  if (model && model !== 'all') {
    segments.push(model);
  }

  const basePath = '/catalog';
  
  // Собираем путь
  let newPath = basePath;
  if (segments.length > 0) {
    newPath += '/' + segments.join('/') + '/';
  } else {
    newPath += '/';
  }

  // Query параметры - только не пустые и с очищенными пробелами
  const params = new URLSearchParams();
  
  const queryParams = {
    mileage_from: mileageFrom,
    mileage_to: mileageTo,
    price_from: priceFrom,
    price_to: priceTo,
    year_from: yearFrom,
    year_to: yearTo,
  };

  Object.entries(queryParams).forEach(([key, value]) => {
    // ✅ Проверяем, что значение не пустое и не состоит только из пробелов
    if (value && value !== '' && value.trim() !== '') {
      params.append(key, value);
    }
  });

  const queryString = params.toString();
  const newURL = window.location.origin + newPath + (queryString ? '?' + queryString : '');

  if (newURL === window.location.href) return;
  window.location.href = newURL;
}